import type { TFunction } from 'i18next';
import { Pages } from 'store/app/enums';

const PAGE_TRANSLATION_KEYS: Record<Pages, string> = {
  [Pages.DASHBOARD]: 'navigation.dashboard',
  [Pages.ENTITIES]: 'organisation.entities',
  [Pages.PLANNER]: 'navigation.planner',
  [Pages.RETURNS]: 'navigation.returns',
  [Pages.REPORTING]: 'navigation.reporting',
  [Pages.BILLING]: 'navigation.billing',
  [Pages.VIES]: 'navigation.vat-number-checker',
  [Pages.USERS]: 'main.users',
  [Pages.SUPPORT]: 'navigation.support',
  [Pages.WHATS_NEW]: 'navigation.whats-new',
  [Pages.PROFILE]: 'navigation.profile',
  [Pages.RETURN]: 'navigation.return',
  [Pages.SUBMISSION]: 'navigation.submission',
  [Pages.REVIEW]: 'navigation.review-submission',
  [Pages.PRICING]: 'navigation.pricing',
  [Pages.ACCESSIBILITY]: 'navigation.accessibility',
};

export function translatePageName(t: TFunction, page: Pages | string): string {
  const key = PAGE_TRANSLATION_KEYS[page as Pages];
  return key ? t(key) : page;
}
